import * as React from "react";
import { useDispatch } from "react-redux";
import { changeSelectedProductType } from "app/pages/Products/actions";
import { bootstrapOpenProductNavigation } from "app/shared/products/openProductNavigation";

export function ProductsOpenProductBootstrap(): null {
  const dispatch = useDispatch();
  const dispatchedRef = React.useRef(false);

  React.useLayoutEffect(() => {
    const intent = bootstrapOpenProductNavigation();
    if (!intent || dispatchedRef.current) {
      return;
    }
    dispatchedRef.current = true;
    dispatch(changeSelectedProductType(intent.productTab, false));
  }, [dispatch]);

  return null;
}